import { DevicePlatform, Role } from '../../enums';
import { IUserData, UserDataClient } from './UserDataClient';
import { IVumFlattenedVehicle } from '../../vum/VumFlattenedVehicleConverter';

interface IVehicle extends IVumFlattenedVehicle {
    readonly vin: string;
    readonly modelName?: string;
    readonly licensePlateNumber?: string;
    readonly exteriorColorText?: string;
    readonly engine?: string;
    readonly modelYear?: string;
}

export class UserDataService {
    constructor(readonly userDataClient: UserDataClient) {
    }

    /**
     *
     * @param vin
     * @param isWcar
     * @param pictures set to true if you need the image of the profile picture for every user (default false)
     * @param roles set to list of roles if you need just this in the response (default all roles)
     */
    public async getUserData(vin: string, isWcar: boolean, pictures?: boolean, roles?: Role[]) {
        return await this.userDataClient.getUserData(vin, isWcar, pictures, roles);
    }

    // /**-
    //  * @deprecated The method should not be used, see {@link getUserData} with role PRIMARY_USER and pictures true
    //  */
    public async getPrimaryUser(vehicle: IVehicle): Promise<IUserData | undefined> {
        const allUsers = await this.userDataClient.getUserData(vehicle.vin, vehicle.devicePlatform === DevicePlatform.WCAR);
        const primaryUser = allUsers.find(user => user.role === "PRIMARY_USER");
        if (primaryUser) {
            return {
                userId: primaryUser.userId,
                nickname: primaryUser.nickname,
                picture: primaryUser.picture,
                name: primaryUser.name,
                role: Role.PRIMARY_USER
            } as IUserData
        }
        return undefined;
    }

    // /**
    //  * @deprecated The method should not be used, see {@link getUserData} with pictures true
    //  */
    public async getAllUsers(vehicle: IVehicle): Promise<IUserData[]> {
        const allUsers = await this.userDataClient.getUserData(vehicle.vin, vehicle.devicePlatform === DevicePlatform.WCAR);
        return allUsers.map<IUserData>(this.adjustUserRole).sort(this.sortByRoleAndUserId);
    }

    private adjustUserRole(userDataResponse: IUserData): IUserData {
        const role = Role[userDataResponse.role as keyof typeof Role] ?? Role.UNKNOWN
        return {
            name: userDataResponse.name,
            role,
            nickname: userDataResponse.nickname,
            picture: userDataResponse.picture,
            userId: userDataResponse.userId
        };
    }

    private sortByRoleAndUserId(user1: IUserData, user2: IUserData) {
        if (user1.role === Role.PRIMARY_USER || (user1.role === Role.SECONDARY_USER && user2.role === Role.GUEST_USER)) {
            return -1;
        }
        if (user2.role === Role.PRIMARY_USER || (user2.role === Role.SECONDARY_USER && user1.role === Role.GUEST_USER)) {
            return 1;
        }
        return user1.userId.localeCompare(user2.userId.toString());
    }
}